import angular from 'angular';

import urls from './urls-constant';

const urlConfig = angular.module('urlConfig', []);

urlConfig.constant('urls', urls);

export default urlConfig.name;
